import axios from 'axios';
import { toast } from 'react-toastify';

const obterPermissoesUsuario = async (nomeUsuario) => {
    const response = await axios.post(`https://almox.pelicano.eng.br/ADM/controller/controllerPermissoesUsuario.php`,
        { nomeUsuario: nomeUsuario, funcao: "consultar" })
    return response.data;
}

export { obterPermissoesUsuario }